import { Box, CircularProgress, Paper, Stack, ToggleButton, ToggleButtonGroup, Toolbar, Typography } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import FavoriteIcon from '@mui/icons-material/Favorite';
import React, { useState } from "react";
import { useSetClubRegistrationMutation, useLazyFetchClubRegistrationQuery } from "../../store/club/ClubApi";
import { myConstants } from "../../shares/Constants";


function ToggleStatus({year, clubId})
{
  const [fetchClubRegistration] = useLazyFetchClubRegistrationQuery( );
  const [clubStatus, setClubStatus] = useState(myConstants.clubModel.status.interested)

  // Mutation ermitteln
  const [setClubRegistration] = useSetClubRegistrationMutation();

  // Merken des Jahres und der ClubId
//  const [currentTournamentYear] = React.useState(year);
//  const [currentClubId] = React.useState(clubId);

  // Auslesen der aktuellen ClubRegistrierung
  React.useEffect( 
    () => {
      fetchClubRegistration(    
        {
          year  : year,
          id    : clubId,
        }  
      ).unwrap(    
      ).then(
        (payload) => setClubStatus(payload.status)
      ).catch(
        (error) => setClubStatus(myConstants.clubModel.status.interested)
      );
    }, [year, clubId, fetchClubRegistration]
  );

  // Änderungen übernehmen und direkt sichern
  const handleChange = async (event, newStatus) => 
  {
    try 
    {
      await setClubRegistration(
        {      
          tournament_id : year,
          club_id       : clubId, 
          status        : newStatus,
        }
      ).unwrap(
      ).then(
        (payload) => setClubStatus(payload.status)
      ).catch(
        (error) => console.error(error) // setClubStatus(myConstants.clubModel.status.interested)
      );
    } 
    catch (err) 
    { 
      console.error(err); 
    }      
  };

  return (
    <ToggleButtonGroup 
      orientation="vertical"
      variant="contained" 
      size="large" 
      aria-label="club-status-group"   
      value={clubStatus}
      exclusive
      onChange={handleChange}>
        <ToggleButton value="interested"><FavoriteIcon /> Interessiert</ToggleButton>
        <ToggleButton value="registered"><HowToRegIcon /> Angemeldet</ToggleButton>
        <ToggleButton value="cancelled"><CancelIcon /> Abgesagt</ToggleButton>
    </ToggleButtonGroup> 
  );
}




export function ClubStatus ({year, club})
{

  return (
    <Paper>
      <Box       
        sx={{
        height:'300px', 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > *': {
          m: 1,
        },
      }}>       
        <Toolbar position="fixed" >      
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "stretch",
              width: '100%',
            }}
          >
            <Typography
              variant="h5"  
              justifyContent="left"  
              sx={{ flexGrow: 1 }}
            >Anmeldestatus</Typography>
          </Stack>
        </Toolbar> 
        {
          club 
          ? <ToggleStatus year={year} clubId={club.id} />   
          : <CircularProgress />
        }
      </Box>
    </Paper>
  );
}